import React, { useEffect, useState } from "react";
import {
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  TablePagination,
  TextField,
  Button,
  Paper,
  Typography,
  InputAdornment,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import "./collectToPayout.css";

const CollectToPayout = () => {
  const [rows, setRows] = useState([]);
  const [searchText, setSearchText] = useState("");
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [masterBalance, setMasterBalance] = useState("0.00");

  useEffect(() => {
    fetch("http://localhost:3002/api/admin/collect-to-payout")
      .then((res) => {
        if (!res.ok) throw new Error(`HTTP error! status: ${res.status}`);
        return res.json();
      })
      .then((data) => {
        // Set debitAmount empty for UI even if backend has value
        const initializedRows = data.map((row) => ({
          ...row,
          debitAmount: "", // force input to be blank
        }));
        setRows(initializedRows);
      })
      .catch((err) => console.error("Error fetching rows:", err));

    // Get master balance
    fetch("http://localhost:3002/api/admin/collect-to-payout/master-balance")
      .then((res) => res.json())
      .then((data) => setMasterBalance(data.masterBalance || "0.00"));
  }, []);

  const handleChangePage = (_, newPage) => setPage(newPage);

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleDebitChange = (id, value) => {
    setRows((prev) =>
      prev.map((row) => (row.id === id ? { ...row, debitAmount: value } : row))
    );
  };

  const handleSubmit = (id) => {
    const row = rows.find((r) => r.id === id);
    fetch(`http://localhost:3002/api/admin/collect-to-payout/${id}`, {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ debitAmount: row.debitAmount }),
    })
      .then((res) => res.json())
      .then(({ updatedRow, masterBalance }) => {
        setMasterBalance(masterBalance);
        setRows((prev) =>
          prev.map((r) =>
            r.id === updatedRow.id
              ? { ...updatedRow, debitAmount: "" } // reset input after submit
              : r
          )
        );
      })
      .catch((err) => {
        console.error("Error submitting:", err);
      });
  };

  const [integerPart, decimalPart] = masterBalance.split(".");

  return (
    <Paper elevation={1} className={"tableContainer"}>
      <div className={"divide"}>
        <Typography
          variant="h6"
          sx={{
            fontWeight: 600,
            p: 2,
            pt: 2.5,
            pb: 0.5,
            fontSize: "20px",
            color: "#79747E",
          }}
        >
          <span style={{ color: "#79747E", paddingRight: "5px" }}>
            Master Load A/c Balance :
          </span>
          <span style={{ color: "#4C4E64" }}>₹{integerPart}</span>
          <span className={"decimalPart"}>.{decimalPart}</span>
        </Typography>

        <TextField
          size="small"
          placeholder="Search..."
          value={searchText}
          onChange={(e) => setSearchText(e.target.value)}
          sx={{
            width: 250,
            borderRadius: "30px",
            marginRight: "17px",
            backgroundColor: "#fff",
            "& .MuiOutlinedInput-root": {
              borderRadius: "8px",
            },
          }}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon style={{ color: "#757575" }} />
              </InputAdornment>
            ),
          }}
        />
      </div>

      <Table className={"table"}>
        <TableHead>
          <TableRow>
            <TableCell className={"headerCell"}>ACCOUNT NAME</TableCell>
            <TableCell className={"headerCell"}>COLLECT BALANCE</TableCell>
            <TableCell className={"headerCell"}>DEBIT AMOUNT</TableCell>
            <TableCell className={"headerCell"}>
              COLLECT FEES (%)
            </TableCell>
            <TableCell className={"headerCell"}>FEE+GST</TableCell>
            <TableCell className={"headerCell"}>
              SETTLEMENT AMOUNT
            </TableCell>
            <TableCell className={"headerCell"}>ERROR MESSAGE</TableCell>
            <TableCell className={"headerCell"}>ACTION</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {rows
            .filter((row) =>
              row.name.toLowerCase().includes(searchText.toLowerCase())
            )
            .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
            .map((row) => (
              <TableRow key={row.id}>
                <TableCell className={"cell"}>{row.name}</TableCell>
                <TableCell className={"cell"}>
                  ₹{row.collectBalance}
                </TableCell>
                <TableCell className={"cell"}>
                  <TextField
                    size="small"
                    value={row.debitAmount}
                    placeholder="Enter amount"
                    onChange={(e) => handleDebitChange(row.id, e.target.value)}
                    className={"input"}
                  />
                </TableCell>
                <TableCell className={"cell"}>
                  {row.collectFees}%
                </TableCell>
                <TableCell className={"cell"}>₹{row.feeGst}</TableCell>
                <TableCell className={"cell"}>
                  ₹{row.settlementAmount}
                </TableCell>
                <TableCell className={"cell"}>
                  {row.error || "-"}
                </TableCell>
                <TableCell className={"cell"}>
                  <Button
                    variant="outlined"
                    size="small"
                    // className={"submitButton"}
                    // onClick={() => handleSubmit(row.id)}
                    sx={{
                      color: "#2348AB",
                      borderRadius: 2,
                      width: 74,
                      fontWeight: 500,
                      textTransform: "none",
                      borderColor: "#E6E0E9",
                      background: row.enable ? "#fff" : "#F6F2FA",
                    }}
                  >
                    Submit
                  </Button>
                </TableCell>
              </TableRow>
            ))}
        </TableBody>
      </Table>

      <TablePagination
        rowsPerPageOptions={[5, 10, 25]}
        component="div"
        count={rows.length}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
    </Paper>
  );
};

export default CollectToPayout;
